import request from '@/utils/request';

//新增模板
export const addMailTemplate = (values) => {
  return request('/mail/addMailTemplate', {
    method: 'POST',
    data: values,
  });
};

//查询模板
export const getQueryMailTemplate = (values) => {
  return request('/mail/queryMailTemplate', {
    method: 'POST',
    data: values,
  });
};
//查询模板
export const updateMailTemplate = (values) => {
  return request('/mail/updateMailTemplate', {
    method: 'POST',
    data: values,
  });
};
